/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { ChatMessageSendingJobNewPageQuotaFragmentDoc } from './ChatMessageSendingJobNewPageQuota/ChatMessageSendingJobNewPageQuota.generated';
import { SegmentFormFragmentDoc } from '../../features/segment/components/SegmentForm/SegmentForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type ConditionInput = {
  clickURLCondition?: SegmentConditionClickUrlConditionInput | null | undefined;
  enqueteAnsweredCondition?: SegmentConditionEnqueteAnsweredInput | null | undefined;
  inflowSourceCondition?: SegmentConditionInflowSourceInput | null | undefined;
  loginLinkCondition?: SegmentConditionLoginLinkInput | null | undefined;
  roomStatusCondition?: SegmentConditionRoomStatusInput | null | undefined;
  userVariableDefinitionCondition?: SegmentConditionUserVariableDefinitionInput | null | undefined;
};

export type ScheduleChatMessageSendingJobInput = {
  messages: Array<ScheduleChatMessageSendingJobInputMessage>;
  scheduledAt?: TimeString | null | undefined;
  target: ScheduleChatMessageSendingJobInputTarget;
};

export type ScheduleChatMessageSendingJobInputImageMessage = {
  altText: string;
  fileName: string;
  linkUri: string;
};

export type ScheduleChatMessageSendingJobInputMessage = {
  imageMessage?: ScheduleChatMessageSendingJobInputImageMessage | null | undefined;
  textMessage?: ScheduleChatMessageSendingJobInputTextMessage | null | undefined;
};

export type ScheduleChatMessageSendingJobInputTarget = {
  allUsers?: any;
  segmentUsers?: ScheduleChatMessageSendingJobInputTargetSegmentUsers | null | undefined;
  targetUsers?: ScheduleChatMessageSendingJobInputTargetTargetUsers | null | undefined;
};

export type ScheduleChatMessageSendingJobInputTargetSegmentUsers = {
  segment: SegmentInput;
};

export type ScheduleChatMessageSendingJobInputTargetTargetUsers = {
  okanentClientUserIds: Array<string>;
};

export type ScheduleChatMessageSendingJobInputTextMessage = {
  selections: Array<string>;
  text: string;
};

export type SegmentConditionClickUrlConditionInput = {
  not: boolean;
  url: string;
};

export type SegmentConditionEnqueteAnsweredInput = {
  enqueteGUID: string;
  not: boolean;
};

export type SegmentConditionInflowSourceInput = {
  inflowSourceDefinitionGUID: string;
  not: boolean;
};

export type SegmentConditionLoginLinkInput = {
  not: boolean;
};

export type SegmentConditionRoomStatusInput = {
  not: boolean;
  status: ChatRoomStatus;
};

export type SegmentConditionUserVariableDefinitionInput = {
  definitionGUID: string | number;
  not: boolean;
  values: Array<string | number>;
};

export type SegmentInput = {
  conditions: Array<ConditionInput>;
};

export type ChatMessageSendingJobNewPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatMessageSendingJobNewPageQuery = { lineMessagingCurrentMonthQuota: { totalUsage: number, quota:
      | { __typename: 'LineMessagingCurrentMonthQuota_Limited', limit: number }
      | { __typename: 'LineMessagingCurrentMonthQuota_None', void: any }
     }, segmentConditionParameters: { enqueteAnsweredCondition: { enquetes: Array<{ guid: string, title: string }> }, inflowSourceCondition: { inflowSources: Array<{ guid: string, inflowSourceName: string }> }, clickURLCondition: { clickUrls: Array<{ guid: string, url: string }> }, userVariableDefinitionCondition: { userVariableDefinitions: Array<{ guid: string, name: string, value:
          | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
          | Record<PropertyKey, never>
         }> } } };

export type ScheduleChatMessageSendingJobMutationVariables = Exact<{
  input: Types.ScheduleChatMessageSendingJobInput;
}>;


export type ScheduleChatMessageSendingJobMutation = { scheduleChatMessageSendingJob:
    | { __typename: 'ScheduleChatMessageSendingJobErrorPayload', reason: string }
    | { __typename: 'ScheduleChatMessageSendingJobSuccessPayload', jobGuid: string | null }
   };


export const ChatMessageSendingJobNewPageDocument = gql`
    query ChatMessageSendingJobNewPage {
  ...ChatMessageSendingJobNewPageQuota
  ...SegmentForm
}
    ${ChatMessageSendingJobNewPageQuotaFragmentDoc}
${SegmentFormFragmentDoc}`;

/**
 * __useChatMessageSendingJobNewPageQuery__
 *
 * To run a query within a Vue component, call `useChatMessageSendingJobNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSendingJobNewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessageSendingJobNewPageQuery();
 */
export function useChatMessageSendingJobNewPageQuery(options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>(ChatMessageSendingJobNewPageDocument, {}, options);
}
export function useChatMessageSendingJobNewPageLazyQuery(options: VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>(ChatMessageSendingJobNewPageDocument, {}, options);
}
export type ChatMessageSendingJobNewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatMessageSendingJobNewPageQuery, ChatMessageSendingJobNewPageQueryVariables>;
export const ScheduleChatMessageSendingJobDocument = gql`
    mutation scheduleChatMessageSendingJob($input: ScheduleChatMessageSendingJobInput!) {
  scheduleChatMessageSendingJob(input: $input) {
    __typename
    ... on ScheduleChatMessageSendingJobSuccessPayload {
      jobGuid
    }
    ... on ScheduleChatMessageSendingJobErrorPayload {
      reason
    }
  }
}
    `;

/**
 * __useScheduleChatMessageSendingJobMutation__
 *
 * To run a mutation, you first call `useScheduleChatMessageSendingJobMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useScheduleChatMessageSendingJobMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useScheduleChatMessageSendingJobMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useScheduleChatMessageSendingJobMutation(options: VueApolloComposable.UseMutationOptions<ScheduleChatMessageSendingJobMutation, ScheduleChatMessageSendingJobMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ScheduleChatMessageSendingJobMutation, ScheduleChatMessageSendingJobMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ScheduleChatMessageSendingJobMutation, ScheduleChatMessageSendingJobMutationVariables>(ScheduleChatMessageSendingJobDocument, options);
}
export type ScheduleChatMessageSendingJobMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ScheduleChatMessageSendingJobMutation, ScheduleChatMessageSendingJobMutationVariables>;